import {
  VendorSummaryWithMarkets,
  VendorSummaryWithMarketsAndFields,
  Field,
} from '../../types/shared/Vendor';

export default function vendorSearchMatch(
  vendor: VendorSummaryWithMarkets,
  searchText: string,
) {
  if (searchText === '') {
    return true;
  }
  searchText = searchText.toLowerCase();
  let { name, products } = vendor;
  if (name != null && name.toLowerCase().includes(searchText)) {
    return true;
  }
  if (
    typeof products === 'string' &&
    products.toLowerCase().includes(searchText)
  ) {
    return true;
  }
  return false;
}

export function vendorSearchFieldsMatch(
  vendor: VendorSummaryWithMarketsAndFields,
  searchText: string,
) {
  if (searchText === '') {
    return true;
  }
  searchText = searchText.toLowerCase();
  let { name } = vendor;
  let productsField = getProductsField(
    Array.isArray(vendor.fields) ? vendor.fields : vendor.fields.list,
  );
  if (name != null && name.toLowerCase().includes(searchText)) {
    return true;
  }
  if (
    typeof productsField?.value === 'string' &&
    productsField?.value?.toLowerCase().includes(searchText)
  ) {
    return true;
  }
  return false;
}

export function getProductsField(vendor: Array<Field>) {
  let field = vendor
    ? vendor.find((field) => String(field.name).toLowerCase() === 'products')
    : null;
  return field ? field : null;
}
